export const SHOW_SUCCESS_NOTIFICATION = 'SHOW_SUCCESS_NOTIFICATION';

export const showSuccessNotification = ( message: string ) => ({
    type: SHOW_SUCCESS_NOTIFICATION,
    payload: {
        message,
    }
});